import { inject, PLATFORM_ID } from "@angular/core";
import { IpService } from "../services/essentials/ip.service";
import { isPlatformBrowser } from "@angular/common";
import { take } from "rxjs";

export function initIp(): void {
    const ipService = inject(IpService);
    const isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

    if (!isBrowser) return;

    ipService
        .fetchIp()
        .pipe(take(1))
        .subscribe();
}